
import { BehaviorSubject, Observable, ReplaySubject, last, lastValueFrom, map, switchMap, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr'
import {ChatService} from "../app/chat/chat.service"
import { HttpBackend, HttpClient, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class MensagemService {

  private _httpStorage: HttpClient;

  constructor(private _httpClient: HttpClient, httpBackend: HttpBackend ){
    this._httpStorage = new HttpClient(httpBackend);
  }

  public progress: number = 0;
  public _dadosConfiguracaoChat: ReplaySubject<any> = new ReplaySubject<any>();
  public _dadosMensagem: ReplaySubject<any> = new ReplaySubject<any>();

  public get dadosConfiguracaoChat(): Observable<any> {
      return this._dadosConfiguracaoChat.asObservable();
  }

  public get dadosMensagem(): Observable<any> {
      return this._dadosMensagem.asObservable();
  }

  getToken(chatApiUrl, catalogo): Observable<any> {
      return this._httpClient.get<any>(`${chatApiUrl}Autenticar/${catalogo}`).pipe(
          tap((response:any) => {
              response;
          }, err => {
              console.error(`Ocorreu um erro durante a Autenticacao: ${JSON.stringify(err)}`);
          })
      );
  }

  getDadosConfiguracaoChat( chatApiUrl, catalogo,  chaveSignalR, token ): Observable<any> {
      const httpOptions = {
          headers: new HttpHeaders({
          'Authorization':  'Bearer ' + token ,
          'sessao-auth' : chaveSignalR
          })
      };

      return this._httpClient.get<any>(`${chatApiUrl}configuracao/${catalogo}`,httpOptions).pipe(
          tap((response:any) => {
              this._dadosConfiguracaoChat.next(response);
          }, err => {
              console.error(`Ocorreu um erro durante a recuperação dos dados de Configuração do Chat:${JSON.stringify(err)}`);
          })
      );
  }

  getMensagens(chatApiUrl, chaveSignalR, guid, token ): Observable<any> {
      const httpOptions = {
          headers: new HttpHeaders({
          'Authorization':  'Bearer ' + token ,
          'sessao-auth' : chaveSignalR
          })
      };
      return this._httpClient.get<any>(`${chatApiUrl}Mensagem/${guid}`,httpOptions).pipe(
          tap((response:any) => {
              this._dadosMensagem.next(response);
          },
          err => {            
              console.error(`Ocorreu um erro durante a recuperação das Mensagens: ${JSON.stringify(err)}`);
          })
      );
  }

  getRecursoHabilitado(chatApiUrl, chaveSignalR, token): Observable<any> {
    const httpOptions = {
        headers: new HttpHeaders({
        'Authorization':  'Bearer ' + token ,
        'sessao-auth' : chaveSignalR
        })
    };
    return this._httpClient.get<any>(`${chatApiUrl}Agente/Habilitado`,httpOptions).pipe(
        tap((response:any) => {
          response;
        },
        err => {
          console.error(`Ocorreu um erro durante a recuperação do Agente Habilitado: ${JSON.stringify(err)}`);
        })
    );
}

  getAgentesStatus(chatApiUrl, chaveSignalR, guid, token ): Observable<any> {
    const httpOptions = {
        headers: new HttpHeaders({
        'Authorization':  'Bearer ' + token ,
        'sessao-auth' : chaveSignalR
        })
    };
    return this._httpClient.get<any>(`${chatApiUrl}Mensagem/${guid}`,httpOptions).pipe(
        tap((response:any) => {
            this._dadosMensagem.next(response);
        },
        err => {
            console.error(`Ocorreu um erro durante a recuperação das Mensagens: ${JSON.stringify(err)}`);
        })
    );
}

  postAnexo( chatApiUrl, chaveSignalR, anexo, guid, token): Observable<any> {
    const cabecalhos = new HttpHeaders()
      .append('sessaoAuth', chaveSignalR)
      .append('guid', guid);

    const assinar = new HttpParams()
      .set('arquivo', anexo.name)
      .set('tamanho', anexo.size);

    return this._httpClient.post<{ url: string, arquivo: string }>(`${chatApiUrl}Arquivo/upload/url`, null, {
      headers: cabecalhos,
      params: assinar
    }).pipe(
      switchMap(assinada => this.enviarParaStorage(assinada.url, anexo).pipe(
        last(null, null),
        switchMap(() => this._httpClient.post(`${chatApiUrl}Anexo/upload/confirmar`, null, {
          headers: cabecalhos,
          params: new HttpParams()
            .set('arquivo', assinada.arquivo)
            .set('legenda', anexo.legenda || '')
        }))
      ))
    );
  }

  private enviarParaStorage(url: string, anexo: File): Observable<any> {
    return this._httpStorage.put(url, anexo, {
      headers: new HttpHeaders({ 'Content-Type': anexo.type || 'application/octet-stream' }),
      reportProgress: true,
      observe: 'events'
    }).pipe(
      tap((evento: any) => {
        if (evento.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(evento.loaded / evento.total * 100);
        }

        if (evento.type === HttpEventType.Response) {
          this.progress = 0;
        }
      })
    );
  }

  /**
     * Get Client IP
     *
     * @param IP
     */
  async getIpAddress()
  {
     var ip : string
     const obj = await lastValueFrom(this._httpClient.get("https://api.ipify.org/?format=json"),{defaultValue: ''})
      .then(
        (value:any) => {ip = value.ip}
      ).catch(
        (err) => {console.error("Erro ao Recuperar ip do Client : " + err); ip = ''}
      )

      return ip
  }
}
